import { render, staticRenderFns } from "./persistentvolumeclaim.vue?vue&type=template&id=7ad433f8&scoped=true&"
import script from "./persistentvolumeclaim.vue?vue&type=script&lang=js&"
export * from "./persistentvolumeclaim.vue?vue&type=script&lang=js&"
import style0 from "./persistentvolumeclaim.vue?vue&type=style&index=0&id=7ad433f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad433f8",
  null
  
)

export default component.exports